var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedln(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_658",
    "data-name": "Group 658",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.262,
    height: 51.261,
    viewBox: "0 0 51.262 51.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M25.63,0A25.63,25.63,0,1,1,0,25.63,25.63,25.63,0,0,1,25.63,0Z",
    transform: "translate(0)",
    fill: "#0b2a46",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_1b033b2faa64ae6da586c6df5e8f50a4",
    "data-name": "1b033b2faa64ae6da586c6df5e8f50a4",
    d: "M12.6,11.675A5.283,5.283,0,0,1,17.04,9.6a5.193,5.193,0,0,1,5.088,5.314c.129,2.776.037,5.562.057,8.343,0,.667-.308.917-.948.9-.858-.022-1.719-.041-2.575.008s-1.172-.291-1.157-1.135c.033-1.888.013-3.778.009-5.666,0-.515.005-1.032-.035-1.544a2.416,2.416,0,0,0-2.434-2.532,2.632,2.632,0,0,0-2.59,2.666c-.037,2.232-.015,4.464-.019,6.7,0,1.495,0,1.495-1.48,1.5-3.191.02-3.19.02-3.191-3.171,0-3.262.023-6.526-.025-9.787-.014-.944.3-1.323,1.244-1.234.545.051,1.1.006,1.648.008C12.272,9.981,12.272,9.982,12.6,11.675ZM.333,17.007c0-1.957.036-3.914-.016-5.869-.024-.914.325-1.231,1.207-1.177.855.052,1.716.029,2.574.011.644-.013.935.249.933.914q-.023,6.179-.009,12.357c0,.659-.284.931-.932.917-.926-.02-1.854-.027-2.78,0-.711.024-.977-.28-.97-.979.023-2.059.008-4.119.008-6.178Zm2.3-9.076A2.491,2.491,0,0,1,0,5.482,2.506,2.506,0,0,1,2.627,3.023a2.453,2.453,0,0,1,2.7,2.461A2.419,2.419,0,0,1,2.633,7.93Z",
    transform: "translate(14.322 12.015)",
    fill: "#e4e4e4",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedln);
export default __webpack_public_path__ + "static/media/linkedln.d8115ab04ca78dff70ac1fcbab55bfe6.svg";
export { ForwardRef as ReactComponent };